// extracted by mini-css-extract-plugin
export default {"friend_list":"friendList_friend_list__cHRhJ"};